// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function isValidDate (inp?: any): boolean {
  return !isNaN(Date.parse(inp))
}
